import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DP_PRODUCT_RELATED_PARTS_FEATURE } from './product-related-parts-feature.constant';
import * as productRelatedPartsEffects from './product-related-parts.effects';
import { productRelatedPartsReducers } from './product-related-parts.reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(DP_PRODUCT_RELATED_PARTS_FEATURE, productRelatedPartsReducers),
    EffectsModule.forFeature(productRelatedPartsEffects)
  ]
})
export class DpProductRelatedPartsStoreModule {}
